import router from './router';
import util from '@/libs/util.js';
import store from '@/store/index';
import NProgress from 'nprogress';

router.beforeEach((to, from, next) => {
  NProgress.start();
  let casid = util.cookies.get('casid');
  // if (util.cookies.get('userType') === '0' || util.cookies.get('userType') === '10') {
  //   casid = null;
  // }

  if (to.path === '/download' || to.path === '/disclaimer') {
    next();
    // } else if (
    //   (global.localStorage.getItem('username') === 'superadmin' ||
    //     global.localStorage.getItem('username') === 'admin' ||
    //     global.localStorage.getItem('username') === '13310029630' ||
    //     global.localStorage.getItem('username') === '15613282905' ||
    //     global.localStorage.getItem('username') === '13633121852') &&
    //   !casid &&
    //   to.path !== '/noAuth'
    // ) {
  } else if (
    (util.cookies.get('userType') === '0' || util.cookies.get('userType') === '10') &&
    !casid &&
    to.path !== '/noAuth'
  ) {
    next();
  } else {
    if (to.path === '/login') {
      if (!casid) {
        next();
      } else {
        store
          .dispatch('d2admin/account/checkCasid', { casid })
          .then(res => {
            if (res.flag) {
              next({
                path: '/attendance'
              });
            } else {
              next({
                path: '/noAuth'
              });
            }
          })
          .catch(() => {
            next();
          });
      }
    } else {
      if (!casid) {
        next({
          path: '/login'
        });
      } else {
        // if (
        //   global.localStorage.getItem('username') === 'superadmin' ||
        //   global.localStorage.getItem('username') === 'admin' ||
        //   global.localStorage.getItem('username') === '13310029630' ||
        //   global.localStorage.getItem('username') === '15613282905' ||
        //   global.localStorage.getItem('username') === '13633121852'
        // ) {
        if (util.cookies.get('userType') === '0' || util.cookies.get('userType') === '10') {
          next();
        } else {
          store
            .dispatch('d2admin/account/checkCasid', { casid })
            .then(res => {
              if (res.flag) {
                if (to.path === '/noAuth') {
                  next({
                    path: '/attendance'
                  });
                } else {
                  next();
                }
              } else if (to.path === '/noAuth') {
                next();
              } else {
                next({
                  path: '/noAuth'
                });
              }
            })
            .catch(() => {
              next();
            });
        }
      }
    }
  }
});
